module.exports = __webpack_public_path__ + "img/hr-rock-big-18.759c3a6d.png";